import React from 'react';
import { Box, Typography } from '@mui/material';
import { ChevronRight } from '@mui/icons-material';

interface SettingsMenuItemProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  onClick: () => void;
}

export const SettingsMenuItem: React.FC<SettingsMenuItemProps> = ({
  title,
  description,
  icon,
  onClick,
}) => {
  return (
    <Box
      sx={{
        p: 2.5,
        cursor: 'pointer',
        borderRadius: 1,
        display: 'flex',
        alignItems: 'flex-start',
        transition: 'all 0.2s ease',
        '&:hover': {
          backgroundColor: 'action.hover',
          '& .setting-icon': {
            color: 'primary.main',
          },
          '& .setting-title': {
            color: 'primary.main',
          },
        },
      }}
      onClick={onClick}
    >
      <Box
        className="setting-icon"
        sx={{
          mr: 2,
          color: 'text.secondary',
          transition: 'color 0.2s ease',
        }}
      >
        {icon}
      </Box>
      <Box sx={{ flex: 1 }}>
        <Typography
          variant="body1"
          fontWeight={500}
          className="setting-title"
          sx={{
            transition: 'color 0.2s ease',
            mb: 0.5,
          }}
        >
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      </Box>
      <ChevronRight
        sx={{
          color: 'action.disabled',
          ml: 1,
        }}
      />
    </Box>
  );
};

export default SettingsMenuItem;
